import { cycleCountIdFormat } from "@redotech/redo-ids/ids";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const completeCycleCount = unaryRpc({
  name: "completeCycleCount" as const,
  input: z.object({ id: cycleCountIdFormat.schema }),
  output: z.object({
    status: z.enum(["completed", "needs_review"]),
    productsOverVariance: z.int(),
  }),
});
